import React from "react";
import AuthPageWrapper from "./AuthPageWrapper";
import Button from "../ui/Button";
import { useNavigate } from "react-router-dom";

const PasswordResetSuccess = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/");
  };

  return (
    <AuthPageWrapper>
      <div className="flex flex-col gap-4 items-center">
        <img src="/assets/images/svg/check.svg" alt="" />
        <div className="flex flex-col w-[450px] items-center">
          <h2 className="text-26px font-bold mb-2">Password Reset Successful</h2>
          <p className="text-sm text-gray-500 mb-6">You can login now!</p>
        </div>
        <Button label="Try Login" type="submit" onClick={handleGetStarted} />
      </div>
    </AuthPageWrapper>
  );
};

export default PasswordResetSuccess;
